import React, { useEffect, useState, useCallback } from 'react';
import { taskApi } from '../../services/api';
import TaskSidePanel from './components/TaskSidePanel';
import LoadingCard from '../../components/LoadingCard';
import Badge from '../../components/ui/Badge';
import { taskStatusVariant } from '../../utils/badgeVariants';

interface TasksPageProps {
  tasks?: Array<any>;
}

const TasksPage: React.FC<TasksPageProps> = ({ tasks: initialTasks = [] }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<Array<any>>(initialTasks);
  const [loading, setLoading] = useState(true);
  const [openTaskId, setOpenTaskId] = useState<number | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await taskApi.getAll();
        setRows(data.data);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const onKey = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') setOpenTaskId(null);
  }, []);
  useEffect(() => {
    if (openTaskId) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [openTaskId, onKey]);

  if (loading) {
    return <LoadingCard title="All Tasks" message="Loading tasks..." />;
  }

  return (
    <div className="theme-card rounded-lg shadow-sm relative border theme-border">
      <div className="flex items-center justify-between px-4 py-3 border-b theme-border">
        <h2 className="text-base font-semibold theme-card-title">All Tasks</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="monday-table">
          <thead>
            <tr>
              <th>Task #</th>
              <th>Title</th>
              <th>Status</th>
              <th>Assignee</th>
              <th>Due</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((t) => (
              <tr key={t.id} onClick={() => setOpenTaskId(t.id)}>
                <td className="font-mono text-xs theme-text-secondary">{t.task_number || t.taskNumber}</td>
                <td className="font-medium theme-text-primary">{t.title}</td>
                <td>
                  <Badge variant={taskStatusVariant(t.status)}>{t.status}</Badge>
                </td>
                <td className="theme-text-secondary">{t.assignee?.name || '-'}</td>
                <td className="theme-text-secondary">{t.due_date ? new Date(t.due_date).toLocaleDateString() : '-'}</td>
                <td className="theme-text-secondary">{t.comments_count ?? t.comments?.length ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {openTaskId && (
        <TaskSidePanel taskId={openTaskId} onClose={() => setOpenTaskId(null)} />
      )}
    </div>
  );
};

export default TasksPage;
